import SSOActions from './constants';
import { ISSOInterface, IActionObject } from './types';

const INITIAL_STATE: ISSOInterface = {
  firstname: null,
  lastname: null,
  email: null,
};

export default function ssoReducer(
  state = INITIAL_STATE,
  action: IActionObject
): ISSOInterface {
  switch (action.type) {
    case SSOActions.SET_SSO_PARAMS:
      return { ...state, ...action.data.ssoData };
    default:
      return state;
  }
}
